export const RouterUrls = {
  AUTH: '/auth',
  SIGN_IN: '/auth/sign-in',
  SIGN_OUT: '/auth/sign-out',

  ROOT: '/',

  USERS: '/users',
  SETTINGS: '/settings',

  TYPE_DOCUMENTATION: '/type-documentation',

  SITE_PICKER: '/',
  SITE_DASHBOARD: '/:siteId',

  VESSEL_DASHBOARD: '/:siteId/vessel',
  VESSEL_DETAILS: '/:siteId/vessel/:imo',

  PORT_UNITS: '/:siteId/port-units',

  SESSIONS: '/:siteId/session',
  SESSION_DETAILS: ':sessionId',

  COMPANIES: '/:siteId/companies',
  COMPANY_DETAILS: '/:siteId/companies/:companyId',

  REPORTS: '/:siteId/reports',

  ENERGY_PLANNER: '/:siteId/energy-planner',
  ENERGY_FORECAST: '/:siteId/energy-planner/energy-forecast',

  BUSINESS_OVERVIEW: '/:siteId/business-overview',
  BUSINESS_OVERVIEW_FINANTIAL_PERFORMANCE: 'financial-performance',
  BUSINESS_OVERVIEW_FINANTIAL_PERFORMANCE_WITH_ID: 'financial-performance/:spuId',

  BUSINESS_OVERVIEW_BUDGET_PLAN: 'budget-plan',
  BUSINESS_OVERVIEW_BUDGET_PLAN_WITH_ID: 'budget-plan/:spuId',
  REPORTING: 'reporting',

  PRICING: 'pricing',
} as const;
